import Vue from "vue";
import VueRouter from "vue-router";

function ifAuthenticated(to, from, next) {
  const currentUser = window.localStorage.getItem('token')
  if (currentUser) {
    next()
  } else {
    next({
      name: 'login',
    })
  }
}
Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "home",
      beforeEnter: ifAuthenticated,
      component: () => import("@/views/dashboard/index.vue"),
      meta: {
        layout: "vertical",
        pageTitle: "",
        breadcrumb: [
          {
            text: "داشبورد",
            active: true,
          },
        ],
      },
    },
    {
      path: '/user/user-profile',
      name: 'userProfile',
      beforeEnter: ifAuthenticated,
      component: () => import('@/views/user/UserProfile.vue'),
      meta: {
        layout: "vertical",
        pageTitle: "",
        breadcrumb: [
          {
            text: "داشبورد",
            active: true,
          },
        ],
      },
    },

    {
      path: '/account-summaries',
      name: 'accountSummaries',
      beforeEnter: ifAuthenticated,
      component: () => import('@/views/dashboard/AccountSummaries.vue'),
      meta: {
        layout: "vertical",
        pageTitle: "صورتحساب",
        breadcrumb: [
          {
            text: "داشبورد",
            active: true,
          },
        ],
      },
    },

    {
      path: '/account-details',
      name: 'accountDetails',
      beforeEnter: ifAuthenticated,
      component: () => import('@/views/dashboard/AccountDetails.vue'),
      meta: {
        layout: "vertical",
        pageTitle: "تراکنش ها",
        breadcrumb: [
          {
            text: "داشبورد",
            active: true,
          },
        ],
      },
    },

    {
      path: '/account-expenses',
      name: 'accountExpenses',
      beforeEnter: ifAuthenticated,
      component: () => import('@/views/dashboard/AccountExpenses.vue'),
      meta: {
        layout: "vertical",
        pageTitle: "هزینه‌های ساختمان",
        breadcrumb: [
          {
            text: "داشبورد",
            active: true,
          },
        ],
      },
    },
    {
      path: '/second-page',
      name: 'second-page',
      component: () => import('@/views/SecondPage.vue'),
      meta: {
        layout: 'vertical',
        pageTitle: 'Second Page',
        breadcrumb: [
          {
            text: 'Second Page',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('@/views/Logout.vue'),
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
